(function () {
	'use strict';

	angular
		.module('uwAgenda.views')
		.controller('ViewDetailController', ViewDetailControllerFn);
	
	ViewDetailControllerFn.$inject = [
        '$timeout',
        'view',
        'Alert', 
        'ViewsService',        
        '$uibModalInstance',
		'$translate',
        'SharedAgendaService'
    ];

	function ViewDetailControllerFn(
        $timeout,
        view,
        Alert, 
        ViewsService,        
        $uibModalInstance,
		$translate,
        SharedAgendaService
    ) {
		var vm = this;
		
		vm.view = view;
        vm.selectedAgenda = null;
        vm.agendas = [];
        vm.showViewUsers = false;
        vm.showNoViewUsersAddedMessage = false;

        activate();

        function activate () {
            initializeAgendas();

            $timeout(function(){
             vm.showViewUsers = true;   
            }, 200);
        }

        function initializeAgendas() {

            // remove agendas that are already in vm.view.viewUsers
            if (vm.view.viewUsers && vm.view.viewUsers.length) {
                var owners = vm.view.viewUsers.map(function(vu) {
                    return vu.userId;
                });

                vm.agendas = SharedAgendaService.data.agendas.filter(function(agenda) {
                    return owners.indexOf(agenda.owner.id) === -1 && agenda.isAgendaAccessibleToCurrentUser;
                });
            } else {
                vm.agendas = SharedAgendaService.data.agendas.filter(function(agenda) {
                    return agenda.isAgendaAccessibleToCurrentUser;
                });
            }
            
            vm.selectedAgenda = vm.agendas.length > 0 ? vm.agendas[0] : null;
        }

        function setSortOrder() {
            var sortOrder = 1;
            vm.view.viewUsers.forEach(vu => vu.sortOrder = sortOrder++);
        }
		
		/* save current item */
		vm.save = function () {
			
            vm.showNoViewUsersAddedMessage = false;
            if (vm.view.viewUsers.length === 0) {
                vm.showNoViewUsersAddedMessage = true;
                return;
            }

			// save or update
			if (vm.view.id > 0) {
				// update
				ViewsService.updateView(vm.view)
                           .then(function() {                        
						Alert.success($translate.instant('view_updated'));
						$uibModalInstance.close();
					});				
			} 
			else {
				// save
				ViewsService.createView(vm.view)
                           .then(function() {                    
					Alert.success($translate.instant('view_created'));
					$uibModalInstance.close();
				});
			}
		};

		// close modal
		vm.abort = function () {
			$uibModalInstance.dismiss();
		};	

        vm.selectAgenda = function(agenda) {
            vm.selectedAgenda = agenda;
        };

        vm.addViewUser = function(user) {
            vm.showNoViewUsersAddedMessage = false;

            var viewUser = {
                userId: user.id,
                userCaption: user.company || user.caption, 
                showInAgendaDayView: true,
                showInAgendaWeekView: true,
                showInNewAppointments: true,
                showInFreeAppointments: true,
                showDayTasks: true
            };

            if (!vm.view.viewUsers) {
                vm.view.viewUsers = [];
            }

            vm.view.viewUsers.push(viewUser);

            initializeAgendas();

            setSortOrder();
        };

        vm.removeViewUser = function(viewUser) {
            var idx = vm.view.viewUsers.indexOf(viewUser);
            if (idx >= 0) {
                vm.view.viewUsers.splice(idx, 1);
            }

            initializeAgendas();

            setSortOrder();
        };

        vm.moveDown = function(viewUser) {
            var sortOrder = viewUser.sortOrder;
            var newSortOrder = sortOrder + 1;

            var otherViewUser = vm.view.viewUsers.filter(vu => vu.sortOrder === newSortOrder)[0];
            
            viewUser.sortOrder = newSortOrder;
            otherViewUser.sortOrder = sortOrder;
        };

        vm.moveUp = function(viewUser) {
            var sortOrder = viewUser.sortOrder;
            var newSortOrder = sortOrder - 1;

            var otherViewUser = vm.view.viewUsers.filter(vu => vu.sortOrder === newSortOrder)[0];
            
            viewUser.sortOrder = newSortOrder;
            otherViewUser.sortOrder = sortOrder;
        };
 	}
})();
